module.exports = __webpack_public_path__ + "img/ac47b4a.png";